var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogNotification = function SvgLogNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19345_59726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.37939 12.6733L6.45873 12.9033C6.73339 13.7013 7.60273 14.1253 8.40073 13.8507C9.19873 13.576 9.62273 12.7067 9.34806 11.9087L9.26873 11.6787",
    stroke: "#EB5757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32315 3.46935L7.12382 2.89068C6.90382 2.25268 6.20848 1.91335 5.56982 2.13335C4.93182 2.35335 4.59248 3.04868 4.81182 3.68668L5.01115 4.26535",
    stroke: "#EB5757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.70257 7.84402C3.15924 6.26669 3.99791 4.54735 5.57524 4.00402L6.71791 3.61069C8.29524 3.06735 10.0146 3.90602 10.5579 5.48335L11.1646 7.24602C11.2799 7.58069 11.5232 7.85535 11.8406 8.01002L12.3839 8.27469C12.7019 8.43002 12.9452 8.70469 13.0599 9.03869C13.2866 9.69669 12.9366 10.414 12.2786 10.6407L5.52191 12.9674C4.86391 13.194 4.14657 12.844 3.91991 12.186C3.80457 11.8514 3.82724 11.4854 3.98191 11.1674L4.24657 10.624C4.40191 10.306 4.42391 9.94002 4.30857 9.60535L3.70257 7.84402Z",
    stroke: "#EB5757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19345_59726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
export { SvgLogNotification as ReactComponent };
export default __webpack_public_path__ + "log-notification.svg";